export const stores = {
  sungod: {
    currency: 'GBP',
    flag: 'gb',
    symbol: '£',
    name: 'British Pound',
    shipping: { domestic: 6.95, international: 11.95, letter: 1.25 },
    subdomains: ['www'],
    websiteId: 2
  },
  eu: {
    currency: 'EUR',
    flag: 'eu',
    symbol: '€',
    name: 'Euro',
    shipping: { domestic: 7.95, international: 13.95, letter: 1.50 },
    subdomains: ['eu'],
    websiteId: 6
  },
  ch: {
    currency: 'CHF',
    flag: 'ch',
    symbol: 'CHF',
    name: 'Swiss Franc',
    shipping: { domestic: 8.95, international: 14.95, letter: 1.50 },
    subdomains: ['ch'],
    websiteId: 7
  },
  us: {
    currency: 'USD',
    flag: 'us',
    symbol: '$',
    name: 'US Dollar',
    shipping: { domestic: 9.95, international: 15.95, letter: 1.95 },
    subdomains: ['us', 'ae', 'hk', 'sg', 'za'],
    websiteId: 5
  },
  ca: {
    currency: 'CAD',
    flag: 'ca',
    symbol: '$',
    name: 'CA Dollar',
    shipping: { domestic: 12.95, international: 21.95, letter: 2.50 },
    subdomains: ['ca'],
    websiteId: 9
  },
  au: {
    currency: 'AUD',
    flag: 'au',
    symbol: '$',
    name: 'AU Dollar',
    shipping: { domestic: 13.95, international: 22.95, letter: 2.50 },
    subdomains: ['au'],
    websiteId: 8
  },
  nz: {
    currency: 'NZD',
    flag: 'nz',
    symbol: '$',
    name: 'NZ Dollar',
    shipping: { domestic: 14.95, international: 24.95, letter: 2.50 },
    subdomains: ['nz'],
    websiteId: 10
  }
}

export const euCountries = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'EL', 'ES', 'FI', 'FR', 'GB', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK']
export const euroCountries = ['AT', 'BA', 'CY', 'DE', 'EE', 'ES', 'FI', 'FR', 'GR', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PT', 'SI', 'SK']